export enum Types {
	CONFRONTAR_DIGITAIS_IIRGD_REQUEST = '@utils/CONFRONTAR_DIGITAIS_IIRGD_REQUEST',
	CONFRONTAR_DIGITAIS_IIRGD_SUCCESS = '@utils/CONFRONTAR_DIGITAIS_IIRGD_SUCCESS',
	CONFRONTAR_DIGITAIS_IIRGD_FAILURE = '@utils/CONFRONTAR_DIGITAIS_IIRGD_FAILURE',
	CONFRONTAR_DIGITAIS_IIRGD_CLEAR = '@utils/CONFRONTAR_DIGITAIS_IIRGD_CLEAR',
}

export interface IConfrontarDigitaisIIRGDState {
	qtdeFalha: number;
	resultado: boolean;
	dedo: null | string;
}

export interface RequestVerificacoes {
	cpf: string;
	rgSp: string;
	finalidade: string;
	tipo: string;
	tipoArquivo: string;
	dedo: number;
	tipoTemplate: string;
	incluirPendentes: boolean;
	digital: ArrayBuffer;
}

export interface ConfrontarDigitaisPayload {
	numeroRg: string;
	dedo: string;
	digital: ArrayBuffer;
}
